import template from './auditprogramresults.html';
import controller from './auditprogramresults.controller';
import './auditprogramresults.styl';

let auditprogramresultsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default auditprogramresultsComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramresults/auditprogramresults.component.js